import React from "react";
import { useInsertName } from "./utils/helpers";
import { PaperDarkBG } from "../kits";
import MonoButton from "./MonoButton";

const SalesSection = () => {
    const name = useInsertName(); // Hol dir den Namen aus dem Kontext


  return (
    <PaperDarkBG>   
    <section className="relative 0 text-white py-6">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-6">
        {/* Left Side: Text Content (Mobile: first, Desktop: second) */}
        <div className="text-center md:text-left md:w-1/2 mb-8 md:mb-0 order-0 md:order-1">
          <h2 className="text-3xl font-mono mb-4"><span className="text-gray-50 text-3xl">5% </span> Wissen Bonus</h2>
          <p className="text-xs mb-0 font-mono ">
           
            
            

          für dich
             {/* personaliserter Name) */}
             <span className="text-orange-50 text-xl font-semibold" > {name}</span>
            
            <span className="font-semibold text-orange-50">
             
            </span> <br />
             um Deine Lernreise zu starten.
              <br />
            <span>Schick uns deine E-Mail-Adresse </span>  <br />
            und wir senden dir 5% extra neues Wissen!
          </p>
          
        </div>

        {/* Right Side: Image (Mobile: second, Desktop: first) */}
        <div className="md:w-1/2 w-full order-0 md:order-1">
        <div className="font-mono sm:text-xs text-xs text-center flex flex-col md:flex-row items-center justify-center md:justify-start mb-4 w-full">
  <input
    type="email"
    placeholder="Deine E-Mail hier"
    className="w-full px-4 py-3 rounded-md text-center text-gray-800 focus:outline-none focus:ring-1 focus:ring-gray-800"
  />
</div>
          <div>
            <MonoButton className=" w-full text-xs bg-gray-50 text-gray-700 px-6 py-3 font-semibold hover:bg-gray-50 hover:text-gray-700 transition duration-300">
              Jetzt Starten
            </MonoButton>
            </div>
        </div>
      </div>
    </section>
    </PaperDarkBG>
  );
};

export default SalesSection;